import { Brick } from './Brick'
import { isSet } from '../../util/functions'

export abstract class LocalBrick extends Brick {
    private _license: string | null

    abstract isContainer(): boolean;
    abstract isOrchestrated(): boolean;
    get license(): string | null { return this._license }

    constructor(license: string | null = null) {
        super()
        this._license = license
    }

    // Indicates if a license is bound to the local (engine) machine)
    isLocalLicense(): boolean {
        return isSet(this.license) && ['su', 'uu', 'nu', 'cs'].includes(this.license ?? '')
    }
}
